<script>
import { FormModel } from '@/components/global/form';
import Countdown from '../../utilities/countdown';
import { scrollToError } from '../../utilities/helpers';

export default {
    name: 'CcAuthenticationForm',

    props: {
        initialData: null,
    },

    data() {
        return {
            loading: false,
            model: new FormModel({
                login_method: null,
                manager_mob_phone: null,
                personal_code: '',
                company_code: '',
                credit_union_id: this.initialData.credit_union_id,
            }),
            auth: {
                active: false,
                code: '',
                remainingTime: 0,
            },
        };
    },

    methods: {
        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            let countdown = null;

            try {
                const loginResponse = await this.$http.post('/legal-entity/authentication', this.model.$);

                this.auth.code = loginResponse.data.data.control_code;
                this.auth.remainingTime = loginResponse.data.data.control_code_time;

                countdown = new Countdown(loginResponse.data.data.control_code_time, (time) => {
                    if (time === 0) {
                        this.resetAuth();
                    } else {
                        this.auth.remainingTime = time;
                    }
                });
                countdown.start();

                this.auth.active = true;

                const finalResponse = await this.$http.post('/legal-entity/authentication/finalize', Object.assign({}, this.model.$, {
                    auth_data: loginResponse.data.data.data,
                }));

                window.location = finalResponse.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            if (countdown) {
                countdown.stop();
            }

            this.resetAuth();
            this.loading = false;
        },

        resetAuth() {
            this.auth.active = false;
            this.auth.code = '';
        },
    },
};
</script>
